const notification = {
  addToCart: {
    addedToCart: 'wurde zum Warenkorb hinzugefügt',
    couponAdded: 'Der <strong>{couponCode}</strong> Coupon wurde erfolgreich hinzugefügt.',
  },
}

export default notification
